export default __webpack_public_path__ + "static/media/Enrico-Sme.a51c466e.png";